/*
 * common.funcs.js
 */

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
// window resize
window.addEventListener('resize', () => {
  vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});



var scroll = new SmoothScroll('a[smoothscroll]', {
  speed: 500,
  speedAsDuration: true,
  header: '[data-scroll-header]',
  easing: 'easeOutQuad',
  updateURL: false
});


var state = {
  startPos: 0
};

$(window).bind('load scroll', function () {
  var threshold = $('[data-scroll-header]').innerHeight();
  var currentPos = window.pageYOffset;
  var bottom = $(document).innerHeight() - $(window).innerHeight();

  // var win_h = $(window).innerHeight();

  if (currentPos > 100) {
    $('.c-scrolldown').addClass('is-hide');
  }
  else{
    $('.c-scrolldown').removeClass('is-hide');
  }

  state.startPos = currentPos;
});


// var gNavFunc = function () {
//   var timer = false;

//   // 下記は変更できます。
//   var $menuBtn = $('.menu');
//   var $header  = $('.header');
//   var $navigation = $('.nav');

//   var init = function init() {
//     bind();
//   };

//   var bind = function bind() {
//     var lastInnerWidth = 0;
//     $(window).bind('load resize', function () {
//       if (timer !== false) {
//         clearTimeout(timer);
//       }
//       timer = setTimeout(function () {
//         if (window.innerWidth > 980) {
//           reset.init();
//           menuFuncs();
//         } else {
//           if (lastInnerWidth != window.innerWidth) {
//             reset.init();
//             menuFuncs();
//           }
//         }
//         lastInnerWidth = window.innerWidth;
//       }, 100);
//     });
//   };

//   var menuFuncs = function menuFuncs() {
//     $menuBtn.on('click', function () {
//       $(this).toggleClass('is-open');
//       $header.toggleClass('is-open');
//       $navigation.toggleClass('is-open');
//     });
//   };

//   var reset = {
//     init: function init() {
//       // すべてリセット
//       $menuBtn.off('click').removeClass('is-open');
//       $header.removeClass('is-open');
//       $navigation.removeClass('is-open');
//     }
//   };
//   return {
//     init: init
//   };
// }().init();
